<template>
  <BaseCard :card-name="tr('Manage Tumor Boards')" :spinnerOn="false">
    <AdminNavigation />
  </BaseCard>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import BaseCard from '@/ux3/cards/BaseCard/BaseCard.vue'
import AdminNavigation from '@/ux3/cards/ManageTumorBoard/AdminNavigation.vue'

const tr = (x) => x // inject('tr')
</script>

